import { UserLocaleSchema, type UserLocale } from '@erp/rpc';
import gtConfig from '../../gt.config.json';

// Catalogs and saved preferences call the US English source `en`. gt-react
// treats a bare `en` source as the same dialect as `en-CA` and would never load
// the Canadian catalog, so the provider sees the source as `en-US` instead.
const RUNTIME_SOURCE_LOCALE = 'en-US';

export const USER_LOCALES: readonly UserLocale[] = UserLocaleSchema.options;

export function toRuntimeLocale(locale: string): string {
  return locale === 'en' ? RUNTIME_SOURCE_LOCALE : locale;
}

export function toUserLocale(runtimeLocale: string): UserLocale | undefined {
  const parsed = UserLocaleSchema.safeParse(
    runtimeLocale === RUNTIME_SOURCE_LOCALE ? 'en' : runtimeLocale,
  );
  return parsed.success ? parsed.data : undefined;
}

export const runtimeGtConfig = {
  ...gtConfig,
  defaultLocale: toRuntimeLocale(gtConfig.defaultLocale),
  locales: gtConfig.locales.map(toRuntimeLocale),
};

const localeNames = new Map(
  USER_LOCALES.map((locale) => {
    const runtimeLocale = toRuntimeLocale(locale);
    // Built once per locale at module load, not per call.
    // react-doctor-disable-next-line react-doctor/js-hoist-intl
    const names = new Intl.DisplayNames([runtimeLocale], {
      type: 'language',
      languageDisplay: 'standard',
    });
    return [locale, names.of(runtimeLocale) ?? runtimeLocale];
  }),
);

/** The locale's own name for itself, e.g. "English (Canada)". */
export function localeDisplayName(locale: UserLocale): string {
  return localeNames.get(locale) ?? locale;
}
